import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const getForms = async () => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "GetForm",
      dat: {
        formInput: "crm/newuser",
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getFormConstants = async () => {
  try {
    const data = JSON.stringify({
      svc: "constants",
      pid: "GetNewUserOptions",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSelectOptions = async () => {
  const urls = [
    "Classification.json",
    "Industry.json",
    "LegalStructure.json",
    "Occupation.json",
    "PurposeOfAccount.json",
    "SourceOfIncome.json",
    // "BusinessCountryIDList.json",
  ];

  try {
    const requests = urls.map((url) => axios.get(`/constants/${url}`, { validateStatus: () => true }));

    const responses = await Promise.all(requests);

    let selectConstants = {};

    console.log(responses);

    responses.forEach((response, index) => {
      if (response.status >= 400 || !Array.isArray(response.data)) {
        return;
      }

      const key = urls[index].split(".")[0].toLowerCase();
      selectConstants[key] = response.data.map((item) => {
        const itemKey = Object.keys(item)[0];
        const info = item[itemKey];
        const selectOptions = {
          value: info.typeID,
          label: info.name,
          key: info.typeID,
        };

        // Only add riskScore if it exists, we will need to also add other data points if needed for constatns
        if (info.riskscore !== undefined) {
          selectOptions.riskScore = info.riskscore;
        }

        return selectOptions;
      });
    });

    console.log(selectConstants);
    return selectConstants;
  } catch (error) {
    console.error("Failed to load select options:", error);
    return {};
  }
};

export const getRequiredConstants = async () => {
  try {
    const data = JSON.stringify({
      svc: "crm_login",
      pid: "listAllRequiredConstants",
      dat: {},
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
